// Single fixed brand theme (JMB navy #01014C, per JMB_App_UI_Style_Spec).
// The multi-color theme picker was removed — only light/dark mode remains.
const brandTheme = {
  id: "navy",
  name: "JMB Navy",
  gradient: "linear-gradient(135deg, #01014C 0%, #1B1B5E 50%, #27277A 100%)",
  primary: "#01014C",
};

const savedDarkMode = localStorage.getItem("darkMode") === "true";

const state = {
  selectedTheme: brandTheme,
  darkMode: savedDarkMode,
};

const getters = {
  selectedTheme: (state) => state.selectedTheme,
  darkMode: (state) => state.darkMode,
};

const actions = {
  toggleDarkMode({ commit, state }) {
    const newDarkMode = !state.darkMode;
    commit("SET_DARK_MODE", newDarkMode);
    localStorage.setItem("darkMode", newDarkMode);
  },
};

const mutations = {
  SET_DARK_MODE(state, darkMode) {
    state.darkMode = darkMode;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
